import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { CurrentEmploymentModel } from 'src/app/model/current-employment.model';

export const RequestAction = createAction('[Current Employer] get data', props<{ accountId: number }>());
export const ResponseAction = createAction('[Current Employer] set data', props<{ payload: CurrentEmploymentModel }>());
